export default function deepEqual(obj1: any, obj2: any): boolean {
  // Если оба значения — это объекты и не null
  if (typeof obj1 === 'object' && obj1 !== null && typeof obj2 === 'object' && obj2 !== null) {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    // Проверяем, что количество ключей совпадает
    if (keys1.length !== keys2.length) {
      return false;
    }

    // Рекурсивно сравниваем все ключи и их значения
    for (let key of keys1) {
      if (!deepEqual(obj1[key], obj2[key])) {
        return false;
      }
    }

    return true;
  }

  // Если это примитивы, сравниваем напрямую
  return obj1 === obj2;
}